import { connect } from 'react-redux';

import { Entities, fetchAll, fetchAllCustomRepository, getEntities, patch, save } from 'src/common/index';
import EmailToJourneyOperator from 'src/components/administration/email-to-journey/email-to-journey-operator';
import { getOwnCompany } from 'src/selectors/bus-companies';
import { push } from 'react-router-redux';

const mapStateToProps = state => {
    return {
        emailToJourneyItems: getEntities(state, Entities.EMAIL_TO_OFFER),
        busCompany: getOwnCompany(state),
        selectedCompany: state.selectedCompany,
    };
};

const EmailToJourneyOperatorContainer = connect(mapStateToProps, {
    fetchAll,
    fetchAllCustomRepository,
    patch,
    save,
    push,
})(EmailToJourneyOperator);

export default EmailToJourneyOperatorContainer;
